import React, { PureComponent } from 'react';
import PT from 'prop-types';
import errorIcon from '../../../assets/images/fail.svg';
import classes from './errorMessage.css';

export default class ErrorMessage extends PureComponent {
  static propTypes = {
    error: PT.shape({
      status: PT.string,
      message: PT.string,
      meta: PT.shape({ fullUrl: PT.string }),
    }),
  };
  static defaultProps = {
    error: null,
  };
  render = () => {
    const { error } = this.props;
    return (
      <div className={classes.errorMessage}>
        <img src={errorIcon} className={classes.errorIcon} alt="Error" />
        <span>Error: </span>{error.message}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/UI_Elements/ErrorMessage.js